import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/marketplace/[package-name]/PageContent.tsx");
